import { Candidate } from '../shared/types';
import { v4 as uuidv4 } from 'uuid';

export const mockCandidates: Candidate[] = [
  {
    id: uuidv4(),
    name: "Sarah Chen",
    email: "sarah.chen@email.com",
    phone: "+1-555-0101",
    location: "San Francisco, CA",
    title: "Senior Full Stack Developer",
    summary: "Experienced full-stack developer with 6 years of expertise in React, Node.js, and cloud technologies. Passionate about building scalable web applications and leading development teams.",
    yearsOfExperience: 6,
    skills: ["JavaScript", "TypeScript", "React", "Node.js", "AWS", "PostgreSQL", "Docker", "GraphQL", "Python", "MongoDB"],
    languages: ["English", "Mandarin"],
    experience: [
      {
        id: uuidv4(),
        company: "TechCorp Inc.",
        position: "Senior Full Stack Developer",
        startDate: "2021-03",
        description: "Led development of microservices architecture serving 100k+ users. Built React frontends and Node.js APIs. Mentored junior developers and improved code quality standards.",
        technologies: ["React", "Node.js", "AWS", "Docker", "PostgreSQL"],
        achievements: ["Reduced API response time by 40%", "Led team of 4 developers", "Implemented CI/CD pipeline"]
      },
      {
        id: uuidv4(),
        company: "StartupXYZ",
        position: "Full Stack Developer",
        startDate: "2019-01",
        endDate: "2021-02",
        description: "Developed complete web applications from scratch using React and Node.js. Worked closely with product team to deliver features rapidly.",
        technologies: ["React", "Node.js", "MongoDB", "Express"],
        achievements: ["Built MVP in 3 months", "Scaled app to 10k users"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "UC Berkeley",
        degree: "Bachelor of Science",
        field: "Computer Science",
        graduationYear: 2018,
        gpa: 3.7
      }
    ],
    certifications: ["AWS Solutions Architect", "Google Cloud Professional"],
    linkedinUrl: "https://linkedin.com/in/sarahchen",
    githubUrl: "https://github.com/sarahchen",
    resumeText: "Sarah Chen Senior Full Stack Developer with 6 years experience React Node.js AWS PostgreSQL Docker GraphQL Python MongoDB. Led microservices architecture 100k users. Mentored developers improved code quality. Built web applications startup MVP scaling. UC Berkeley Computer Science degree. AWS Solutions Architect certified.",
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-15')
  },
  {
    id: uuidv4(),
    name: "Marcus Rodriguez",
    email: "marcus.rodriguez@email.com",
    phone: "+1-555-0102",
    location: "Austin, TX",
    title: "DevOps Engineer",
    summary: "DevOps specialist with 5 years of experience in cloud infrastructure, containerization, and CI/CD pipelines. Expert in Kubernetes, AWS, and infrastructure automation.",
    yearsOfExperience: 5,
    skills: ["Kubernetes", "Docker", "AWS", "Terraform", "Jenkins", "Python", "Bash", "Prometheus", "Grafana", "Ansible"],
    languages: ["English", "Spanish"],
    experience: [
      {
        id: uuidv4(),
        company: "CloudTech Solutions",
        position: "Senior DevOps Engineer",
        startDate: "2022-06",
        description: "Managed Kubernetes clusters for multiple client applications. Implemented monitoring and alerting systems. Automated deployment processes reducing deployment time by 60%.",
        technologies: ["Kubernetes", "AWS EKS", "Terraform", "Prometheus", "Grafana"],
        achievements: ["Reduced deployment time by 60%", "99.9% uptime achievement", "Cost optimization saving 30%"]
      },
      {
        id: uuidv4(),
        company: "Digital Innovations",
        position: "DevOps Engineer",
        startDate: "2020-08",
        endDate: "2022-05",
        description: "Built CI/CD pipelines using Jenkins and GitLab. Managed AWS infrastructure and implemented security best practices.",
        technologies: ["Jenkins", "AWS", "Docker", "GitLab", "Python"],
        achievements: ["Implemented security compliance", "Reduced infrastructure costs by 25%"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "University of Texas at Austin",
        degree: "Bachelor of Science",
        field: "Information Technology",
        graduationYear: 2019
      }
    ],
    certifications: ["AWS DevOps Engineer Professional", "Certified Kubernetes Administrator", "HashiCorp Terraform Associate"],
    linkedinUrl: "https://linkedin.com/in/marcusrodriguez",
    githubUrl: "https://github.com/marcusrodriguez",
    resumeText: "Marcus Rodriguez DevOps Engineer 5 years experience Kubernetes Docker AWS Terraform Jenkins Python Bash monitoring automation. Managed Kubernetes clusters deployment automation 60% faster. CI/CD pipelines security compliance cost optimization. University Texas Information Technology degree. AWS DevOps Kubernetes Terraform certified.",
    createdAt: new Date('2024-01-02'),
    updatedAt: new Date('2024-01-16')
  },
  {
    id: uuidv4(),
    name: "Emily Watson",
    email: "emily.watson@email.com",
    phone: "+1-555-0103",
    location: "New York, NY",
    title: "Data Scientist",
    summary: "Data scientist with 4 years of experience in machine learning, statistical analysis, and data visualization. Expertise in Python, R, and cloud-based analytics platforms.",
    yearsOfExperience: 4,
    skills: ["Python", "R", "Machine Learning", "TensorFlow", "PyTorch", "SQL", "Tableau", "AWS", "Pandas", "NumPy"],
    languages: ["English", "French"],
    experience: [
      {
        id: uuidv4(),
        company: "Analytics Pro",
        position: "Senior Data Scientist",
        startDate: "2022-09",
        description: "Developed predictive models for customer behavior analysis. Built recommendation systems using deep learning. Led data science team on multiple client projects.",
        technologies: ["Python", "TensorFlow", "AWS SageMaker", "SQL", "Tableau"],
        achievements: ["Improved model accuracy by 25%", "Generated $2M in additional revenue", "Led team of 3 data scientists"]
      },
      {
        id: uuidv4(),
        company: "Data Insights Corp",
        position: "Data Scientist",
        startDate: "2021-01",
        endDate: "2022-08",
        description: "Analyzed large datasets to identify business trends. Created dashboards and reports for executive team. Implemented A/B testing frameworks.",
        technologies: ["Python", "R", "SQL", "Tableau", "AWS"],
        achievements: ["Reduced churn rate by 15%", "Automated reporting saving 20 hours/week"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "Columbia University",
        degree: "Master of Science",
        field: "Data Science",
        graduationYear: 2020
      },
      {
        id: uuidv4(),
        institution: "NYU",
        degree: "Bachelor of Science",
        field: "Mathematics",
        graduationYear: 2018
      }
    ],
    certifications: ["AWS Certified Machine Learning", "Google Analytics Certified"],
    linkedinUrl: "https://linkedin.com/in/emilywatson",
    portfolioUrl: "https://emilywatson.github.io",
    resumeText: "Emily Watson Data Scientist 4 years experience machine learning Python R TensorFlow PyTorch SQL Tableau AWS analytics. Predictive models customer behavior recommendation systems deep learning. Model accuracy 25% improvement revenue generation. Columbia Data Science NYU Mathematics degrees. AWS Machine Learning certified.",
    createdAt: new Date('2024-01-03'),
    updatedAt: new Date('2024-01-17')
  },
  {
    id: uuidv4(),
    name: "David Kim",
    email: "david.kim@email.com",
    phone: "+1-555-0104",
    location: "Seattle, WA",
    title: "Frontend Developer",
    summary: "Creative frontend developer with 3 years of experience building responsive web applications. Specialized in React, Vue.js, and modern CSS frameworks with a focus on user experience.",
    yearsOfExperience: 3,
    skills: ["React", "Vue.js", "JavaScript", "TypeScript", "CSS", "Sass", "Tailwind CSS", "Webpack", "Next.js", "Figma"],
    languages: ["English", "Korean"],
    experience: [
      {
        id: uuidv4(),
        company: "UX Design Studio",
        position: "Frontend Developer",
        startDate: "2022-01",
        description: "Developed responsive web applications for various clients. Collaborated with designers to implement pixel-perfect UIs. Optimized application performance and accessibility.",
        technologies: ["React", "TypeScript", "Tailwind CSS", "Next.js"],
        achievements: ["Improved page load speed by 50%", "98% accessibility score", "Client satisfaction rate 95%"]
      },
      {
        id: uuidv4(),
        company: "WebDev Agency",
        position: "Junior Frontend Developer",
        startDate: "2021-06",
        endDate: "2021-12",
        description: "Built interactive websites using Vue.js and vanilla JavaScript. Worked on mobile-first responsive designs.",
        technologies: ["Vue.js", "JavaScript", "CSS", "Sass"],
        achievements: ["Delivered 15+ projects on time", "Mobile-first design implementation"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "University of Washington",
        degree: "Bachelor of Arts",
        field: "Digital Media",
        graduationYear: 2021
      }
    ],
    linkedinUrl: "https://linkedin.com/in/davidkim",
    portfolioUrl: "https://davidkim.dev",
    resumeText: "David Kim Frontend Developer 3 years experience React Vue.js JavaScript TypeScript CSS Sass Tailwind responsive web applications user experience. Pixel-perfect UI implementation performance optimization accessibility. Page load speed 50% improvement. University Washington Digital Media degree.",
    createdAt: new Date('2024-01-04'),
    updatedAt: new Date('2024-01-18')
  },
  {
    id: uuidv4(),
    name: "Jennifer Liu",
    email: "jennifer.liu@email.com",
    phone: "+1-555-0105",
    location: "Boston, MA",
    title: "Backend Engineer",
    summary: "Backend engineer with 7 years of experience in distributed systems, microservices, and database optimization. Expert in Java, Spring Boot, and cloud architectures.",
    yearsOfExperience: 7,
    skills: ["Java", "Spring Boot", "Microservices", "PostgreSQL", "Redis", "Kafka", "AWS", "Docker", "Maven", "JUnit"],
    languages: ["English", "Mandarin", "Cantonese"],
    experience: [
      {
        id: uuidv4(),
        company: "Enterprise Solutions Inc",
        position: "Senior Backend Engineer",
        startDate: "2020-05",
        description: "Architected and implemented microservices handling millions of transactions daily. Optimized database queries and implemented caching strategies. Led backend team of 6 engineers.",
        technologies: ["Java", "Spring Boot", "PostgreSQL", "Redis", "Kafka", "AWS"],
        achievements: ["Handled 10M+ daily transactions", "Reduced query time by 70%", "Led team of 6 engineers"]
      },
      {
        id: uuidv4(),
        company: "FinTech Startup",
        position: "Backend Developer",
        startDate: "2018-03",
        endDate: "2020-04",
        description: "Developed payment processing systems with high availability requirements. Implemented fraud detection algorithms and real-time monitoring.",
        technologies: ["Java", "Spring", "MySQL", "Redis", "Docker"],
        achievements: ["99.99% system uptime", "Fraud detection accuracy 95%"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "MIT",
        degree: "Master of Science",
        field: "Computer Science",
        graduationYear: 2018
      },
      {
        id: uuidv4(),
        institution: "Boston University",
        degree: "Bachelor of Science",
        field: "Software Engineering",
        graduationYear: 2016
      }
    ],
    certifications: ["AWS Solutions Architect Professional", "Oracle Java SE 11 Developer"],
    linkedinUrl: "https://linkedin.com/in/jenniferliu",
    githubUrl: "https://github.com/jenniferliu",
    resumeText: "Jennifer Liu Backend Engineer 7 years experience Java Spring Boot microservices PostgreSQL Redis Kafka AWS distributed systems database optimization. Millions daily transactions query optimization caching strategies. Payment processing fraud detection real-time monitoring. MIT Computer Science Boston University Software Engineering degrees. AWS Solutions Architect Oracle Java certified.",
    createdAt: new Date('2024-01-05'),
    updatedAt: new Date('2024-01-19')
  },
  {
    id: uuidv4(),
    name: "Alex Thompson",
    email: "alex.thompson@email.com",
    phone: "+1-555-0106",
    location: "Denver, CO",
    title: "Mobile Developer",
    summary: "Mobile developer with 4 years of experience in iOS and Android development. Skilled in Swift, Kotlin, React Native, and cross-platform mobile solutions.",
    yearsOfExperience: 4,
    skills: ["Swift", "Kotlin", "React Native", "iOS", "Android", "Flutter", "Firebase", "SQLite", "Git", "Xcode"],
    languages: ["English"],
    experience: [
      {
        id: uuidv4(),
        company: "Mobile Innovation Labs",
        position: "Senior Mobile Developer",
        startDate: "2022-03",
        description: "Developed native iOS and Android applications for e-commerce clients. Implemented real-time features using Firebase. Led mobile development best practices.",
        technologies: ["Swift", "Kotlin", "Firebase", "SQLite"],
        achievements: ["Apps downloaded 500k+ times", "4.8+ app store ratings", "Reduced crash rate to <0.1%"]
      },
      {
        id: uuidv4(),
        company: "App Development Co",
        position: "Mobile Developer",
        startDate: "2020-07",
        endDate: "2022-02",
        description: "Built cross-platform mobile apps using React Native. Integrated with REST APIs and implemented offline functionality.",
        technologies: ["React Native", "JavaScript", "Firebase", "Redux"],
        achievements: ["Delivered 8 mobile apps", "Cross-platform compatibility 100%"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "Colorado State University",
        degree: "Bachelor of Science",
        field: "Computer Science",
        graduationYear: 2020
      }
    ],
    certifications: ["iOS App Development with Swift", "Android Developer Nanodegree"],
    linkedinUrl: "https://linkedin.com/in/alexthompson",
    portfolioUrl: "https://alexthompson.mobile",
    resumeText: "Alex Thompson Mobile Developer 4 years experience Swift Kotlin React Native iOS Android Flutter Firebase cross-platform mobile solutions. Native mobile applications e-commerce real-time features offline functionality. 500k downloads 4.8 app store ratings crash rate reduction. Colorado State Computer Science degree. iOS Swift Android certified.",
    createdAt: new Date('2024-01-06'),
    updatedAt: new Date('2024-01-20')
  },
  {
    id: uuidv4(),
    name: "Rachel Green",
    email: "rachel.green@email.com",
    phone: "+1-555-0107",
    location: "Chicago, IL",
    title: "Product Manager",
    summary: "Product manager with 5 years of experience leading cross-functional teams to deliver successful digital products. Strong background in agile methodologies and user research.",
    yearsOfExperience: 5,
    skills: ["Product Management", "Agile", "Scrum", "User Research", "A/B Testing", "SQL", "Analytics", "Wireframing", "Roadmapping", "Stakeholder Management"],
    languages: ["English"],
    experience: [
      {
        id: uuidv4(),
        company: "Product Innovation Corp",
        position: "Senior Product Manager",
        startDate: "2021-08",
        description: "Led product development for SaaS platform serving 50k+ users. Managed roadmap, conducted user research, and coordinated with engineering teams. Increased user engagement by 40%.",
        technologies: ["Analytics tools", "A/B testing platforms", "Wireframing tools"],
        achievements: ["Increased user engagement by 40%", "Reduced churn by 25%", "Led team of 12 people"]
      },
      {
        id: uuidv4(),
        company: "Tech Startup",
        position: "Product Manager",
        startDate: "2019-09",
        endDate: "2021-07",
        description: "Managed product lifecycle from ideation to launch. Conducted market research and competitive analysis. Worked closely with UX/UI designers.",
        achievements: ["Launched 3 major features", "Market research for new verticals"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "Northwestern University",
        degree: "Master of Business Administration",
        field: "Technology Management",
        graduationYear: 2019
      },
      {
        id: uuidv4(),
        institution: "University of Illinois",
        degree: "Bachelor of Science",
        field: "Industrial Engineering",
        graduationYear: 2017
      }
    ],
    certifications: ["Certified Scrum Product Owner", "Google Analytics Certified"],
    linkedinUrl: "https://linkedin.com/in/rachelgreen",
    resumeText: "Rachel Green Product Manager 5 years experience agile scrum user research A/B testing analytics roadmapping stakeholder management. SaaS platform 50k users cross-functional teams digital products. User engagement 40% increase churn reduction. Northwestern MBA Technology Management University Illinois Industrial Engineering degrees. Scrum Product Owner Google Analytics certified.",
    createdAt: new Date('2024-01-07'),
    updatedAt: new Date('2024-01-21')
  },
  {
    id: uuidv4(),
    name: "Michael Brown",
    email: "michael.brown@email.com",
    phone: "+1-555-0108",
    location: "Portland, OR",
    title: "Cloud Architect",
    summary: "Cloud architect with 8 years of experience designing and implementing scalable cloud solutions. Expert in AWS, Azure, and Google Cloud with focus on security and cost optimization.",
    yearsOfExperience: 8,
    skills: ["AWS", "Azure", "Google Cloud", "Terraform", "CloudFormation", "Kubernetes", "Security", "Cost Optimization", "Architecture Design", "Python"],
    languages: ["English"],
    experience: [
      {
        id: uuidv4(),
        company: "Cloud Solutions Enterprise",
        position: "Principal Cloud Architect",
        startDate: "2020-01",
        description: "Designed cloud architectures for Fortune 500 companies. Led cloud migration projects and implemented security frameworks. Achieved significant cost savings through optimization.",
        technologies: ["AWS", "Azure", "Terraform", "Kubernetes", "Python"],
        achievements: ["Saved clients $5M+ annually", "Led 20+ migration projects", "Zero security incidents"]
      },
      {
        id: uuidv4(),
        company: "Infrastructure Consulting",
        position: "Cloud Architect",
        startDate: "2017-06",
        endDate: "2019-12",
        description: "Implemented multi-cloud strategies and disaster recovery solutions. Mentored junior architects and established best practices.",
        technologies: ["AWS", "Azure", "CloudFormation", "Docker"],
        achievements: ["99.99% uptime achievement", "Disaster recovery in <4 hours"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "Oregon State University",
        degree: "Master of Science",
        field: "Computer Engineering",
        graduationYear: 2016
      }
    ],
    certifications: ["AWS Solutions Architect Professional", "Azure Solutions Architect Expert", "Google Cloud Professional Cloud Architect"],
    linkedinUrl: "https://linkedin.com/in/michaelbrown",
    resumeText: "Michael Brown Cloud Architect 8 years experience AWS Azure Google Cloud Terraform CloudFormation Kubernetes security cost optimization architecture design. Fortune 500 cloud migration security frameworks multi-cloud strategies disaster recovery. Cost savings 5M annually zero security incidents. Oregon State Computer Engineering degree. AWS Azure Google Cloud certified architect.",
    createdAt: new Date('2024-01-08'),
    updatedAt: new Date('2024-01-22')
  },
  {
    id: uuidv4(),
    name: "Lisa Wang",
    email: "lisa.wang@email.com",
    phone: "+1-555-0109",
    location: "Los Angeles, CA",
    title: "UX/UI Designer",
    summary: "UX/UI designer with 4 years of experience creating user-centered designs for web and mobile applications. Skilled in design thinking, prototyping, and user research methodologies.",
    yearsOfExperience: 4,
    skills: ["UX Design", "UI Design", "Figma", "Adobe XD", "Sketch", "Prototyping", "User Research", "Design Systems", "HTML", "CSS"],
    languages: ["English", "Mandarin"],
    experience: [
      {
        id: uuidv4(),
        company: "Design Studio Pro",
        position: "Senior UX/UI Designer",
        startDate: "2022-04",
        description: "Led design for mobile and web applications across various industries. Conducted user research and usability testing. Created comprehensive design systems.",
        technologies: ["Figma", "Adobe XD", "Prototyping tools"],
        achievements: ["Improved user satisfaction by 35%", "Reduced support tickets by 50%", "Created design system used by 3 teams"]
      },
      {
        id: uuidv4(),
        company: "Creative Agency",
        position: "UX/UI Designer",
        startDate: "2020-08",
        endDate: "2022-03",
        description: "Designed user interfaces for client projects ranging from startups to enterprise. Collaborated with developers to ensure design feasibility.",
        technologies: ["Sketch", "Figma", "InVision"],
        achievements: ["Designed 25+ successful projects", "Client retention rate 90%"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "Art Center College of Design",
        degree: "Bachelor of Fine Arts",
        field: "Graphic Design",
        graduationYear: 2020
      }
    ],
    certifications: ["Google UX Design Certificate", "Adobe Certified Expert"],
    linkedinUrl: "https://linkedin.com/in/lisawang",
    portfolioUrl: "https://lisawang.design",
    resumeText: "Lisa Wang UX UI Designer 4 years experience user-centered design web mobile applications Figma Adobe XD Sketch prototyping user research design thinking. User satisfaction 35% improvement support tickets 50% reduction design systems. Usability testing client projects startup enterprise. Art Center Graphic Design degree. Google UX Adobe certified.",
    createdAt: new Date('2024-01-09'),
    updatedAt: new Date('2024-01-23')
  },
  {
    id: uuidv4(),
    name: "James Wilson",
    email: "james.wilson@email.com",
    phone: "+1-555-0110",
    location: "Miami, FL",
    title: "Cybersecurity Specialist",
    summary: "Cybersecurity specialist with 6 years of experience in threat analysis, penetration testing, and security architecture. Expert in network security, incident response, and compliance frameworks.",
    yearsOfExperience: 6,
    skills: ["Penetration Testing", "Network Security", "Incident Response", "SIEM", "Vulnerability Assessment", "Python", "Linux", "CISSP", "ISO 27001", "NIST"],
    languages: ["English", "Spanish"],
    experience: [
      {
        id: uuidv4(),
        company: "CyberSec Solutions",
        position: "Senior Cybersecurity Specialist",
        startDate: "2021-02",
        description: "Conducted security assessments for enterprise clients. Implemented security monitoring systems and incident response procedures. Led security awareness training programs.",
        technologies: ["SIEM tools", "Penetration testing tools", "Python scripts"],
        achievements: ["Reduced security incidents by 60%", "Achieved ISO 27001 compliance", "Trained 200+ employees"]
      },
      {
        id: uuidv4(),
        company: "Financial Security Corp",
        position: "Cybersecurity Analyst",
        startDate: "2018-09",
        endDate: "2021-01",
        description: "Monitored security events and responded to incidents. Performed vulnerability assessments and implemented security controls.",
        technologies: ["SIEM", "Vulnerability scanners", "Linux"],
        achievements: ["Response time under 30 minutes", "Zero data breaches"]
      }
    ],
    education: [
      {
        id: uuidv4(),
        institution: "Florida International University",
        degree: "Bachelor of Science",
        field: "Information Security",
        graduationYear: 2018
      }
    ],
    certifications: ["CISSP", "CEH", "Security+", "GCIH"],
    linkedinUrl: "https://linkedin.com/in/jameswilson",
    resumeText: "James Wilson Cybersecurity Specialist 6 years experience threat analysis penetration testing security architecture network security incident response compliance frameworks. Security assessments enterprise SIEM monitoring security awareness training. Security incidents 60% reduction ISO 27001 compliance zero data breaches. Florida International Information Security degree. CISSP CEH Security+ GCIH certified.",
    createdAt: new Date('2024-01-10'),
    updatedAt: new Date('2024-01-24')
  }
];
